import React from 'react';
import ReactECharts from 'echarts-for-react';
import NoDataFound from '../../NoDataFound';

const InstituteProgramCompletionChart = ({ stats }) => {
    // Check if stats exist and is an array
    if (!stats || !Array.isArray(stats) || stats.length === 0) {
        return <NoDataFound message='Data not available' height='350px' />;
    }

    const getOption = () => {
        const titles = stats.map(item => item.program_title);
        const enrolled = stats.map(item => item.total_enrolled_students);
        const completed = stats.map(item => item.completed_students_count);

        return {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            legend: {
                data: ['Total Enrolled Students', 'Completed Students'],
                top: 0
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '15%', // Increased bottom margin for rotated labels
                containLabel: true
            },
            xAxis: {
                type: 'category',
                data: titles,
                axisLabel: {
                    interval: 0,
                    rotate: 30, // Rotate labels for better readability
                    width: 100,
                    overflow: 'truncate'
                }
            },
            yAxis: {
                type: 'value',
                boundaryGap: [0, 0.01]
            },
            series: [
                {
                    name: 'Total Enrolled Students',
                    type: 'bar',
                    data: enrolled,
                    itemStyle: {
                        color: '#36348E'
                    },
                    label: {
                        show: true,
                        position: 'top'
                    }
                },
                {
                    name: 'Completed Students',
                    type: 'bar',
                    data: completed,
                    itemStyle: {
                        color: '#20c997'
                    },
                    label: {
                        show: true,
                        position: 'top'
                    }
                }
            ]
        };
    };

    return (
        <ReactECharts
            option={getOption()}
            style={{ height: '350px', width: '100%' }}
            notMerge={true}
            lazyUpdate={true}
        />
    );
};

export default InstituteProgramCompletionChart;
